import { Observable } from 'rxjs';
import {
  CompanyProvisionResult,
  CompanyStandaloneResult,
} from '@app/domain/models/tpv/company.model';
import {
  ProvisionCompanyRequest,
  ProvisionCompanyStandaloneRequest,
} from '@app/data/dtos/tpv/company-provision.dto';

/**
 * Port para provisionar una Company (tenant) en el TPV (multi-company, §6).
 * Permiso backend: IsAdmin.
 */
export abstract class CompanyProvisionRepository {
  /** Provisiona en TPV una Company org existente (id_company conocido). Idempotente. */
  abstract provisionCompany(
    idCompany: string,
    request: ProvisionCompanyRequest,
  ): Observable<CompanyProvisionResult>;

  /**
   * Crea un tenant TPV standalone (sin alta previa de Banca). El `id_company` es
   * SALIDA. `Idempotency-Key` obligatoria (anti-duplicado).
   */
  abstract provisionStandalone(
    request: ProvisionCompanyStandaloneRequest,
    idempotencyKey: string,
  ): Observable<CompanyStandaloneResult>;
}
